import React, { } from 'react'
import { IonHeader, IonToolbar, IonTitle, IonButtons, IonButton, IonIcon, IonMenuButton } from '@ionic/react'
import { informationCircle } from 'ionicons/icons'
import { useHistory } from 'react-router';

interface Props {
  title: string,
  infoBtn: boolean,
  menuBtn: boolean
}

const Toolbar: React.FC<Props> = (props: Props) => {
  const history = useHistory();

  function goToInformation() {
    history.push('/about');
  }

  return (
    <IonHeader>
      <IonToolbar color="primary">
        {
          props.menuBtn &&
          <IonButtons slot="start">
            <IonMenuButton />
          </IonButtons>
        }
        <IonTitle> {props.title} </IonTitle>
        {
          props.infoBtn &&
          <IonButtons slot="end">
            <IonButton slot="start" onClick={() => goToInformation()} >
              <IonIcon color="primary" icon={informationCircle} />
            </IonButton>
          </IonButtons>
        }
      </IonToolbar>
    </IonHeader>
  )
}

export default Toolbar
